import api from './api'

export const dashboardService = {
  // Get dashboard stats
  getStats: async () => {
    const response = await api.get('/dashboard/stats')
    return response.data
  },

  // Get queue stats
  getQueueStats: async () => {
    const response = await api.get('/dashboard/queue')
    return response.data
  },

  // Get warehouse stats
  getWarehouseStats: async () => {
    const response = await api.get('/warehouse/stats')
    return response.data
  },

  // Get warehouse entries
  getWarehouseEntries: async (params = {}) => {
    const response = await api.get('/warehouse/entries', { params })
    return response.data
  },

  // Get activity logs
  getActivityLogs: async (params = {}) => {
    const response = await api.get('/activity-logs', { params })
    return response.data
  },

  // Reports
  getCustomSchoolReport: async (params = {}) => {
    const response = await api.get('/reports/custom-schools', { params })
    return response.data
  },

  getVendorReport: async (params = {}) => {
    const response = await api.get('/reports/vendors', { params })
    return response.data
  },

  getSPKStatusReport: async (params = {}) => {
    const response = await api.get('/reports/spk-status', { params })
    return response.data
  },

  getOperatorReport: async (params = {}) => {
    const response = await api.get('/reports/operators', { params })
    return response.data
  },

  getComcolorReport: async (params = {}) => {
    const response = await api.get('/reports/comcolor', { params })
    return response.data
  },

  getLifecycleReport: async (params = {}) => {
    const response = await api.get('/reports/lifecycle', { params })
    return response.data
  }
}

export default dashboardService
